import {withGoogleMapApi} from './Utils';

type Pin = {
	identifier: string;
	lat: number;
	lng: number;
};
const render = ($node: HTMLElement, onMarkerClick?: (identifier: string) => void) => {
	const {Map, Marker, LatLng, event, Size, Point} = window.google.maps;
	const pins = JSON.parse($node.dataset.pins || '[]') as Pin[];

	if (pins.length) {
		const map = new Map(
			$node,
			{
				center: pins[0],
				zoom: 12,
			}
		);

		const onTilesLoaded = () => {
			const latLngBounds: google.maps.LatLngBounds = map.getBounds();

			pins.forEach(({lat, lng, identifier = '122'}) => {
				const position = new LatLng(lat, lng);
				const marker = new Marker({
					map,
					position,
					icon: {
						url: $node.dataset.iconSrc,
						size: new Size(32, 32),
						scaledSize: new Size(32, 32),
						anchor: new Point(16, 16),
					},
				});

				if (onMarkerClick !== undefined) {
					marker.addListener('click', () => onMarkerClick(identifier));
				}

				latLngBounds.extend(position);
			});

			map.fitBounds(latLngBounds);
		}

		event.addListenerOnce(map, 'tilesloaded', onTilesLoaded);
	}
};

function mapsFallback($node: HTMLElement)
{
	let mapsFallback = true;

	// @ts-ignore
	if (typeof CCM == 'undefined') {
		mapsFallback = false;
	} else {
		// @ts-ignore
		CCM.acceptedEmbeddings.forEach(element => {
			if(element.name == 'Google Maps') {
				mapsFallback = false;
			}
		})
	}

	if (!mapsFallback) {
		const mapsFallbackElement = $node.querySelector("[data-mapsFallback]");
		if (mapsFallbackElement instanceof HTMLElement) {
			const attribute = mapsFallbackElement.getAttribute('data-mapsFallback');
			if (attribute) {
				mapsFallbackElement.classList.add(attribute);
			}
		}
	}
}

export default ($node: HTMLElement) => {
	const apiKey = $node.dataset.googleApiKey!;
	const $mapNode = $node.querySelector('[data-selector="map"]') as HTMLElement;

	window.addEventListener('ccm19WidgetClosed', function () {
		mapsFallback($node);
	});
	mapsFallback($node);

	const onMarkerClick = (identifier: string) => {
		const $target = document.querySelector(`#id_${identifier}`);

		if ($target) {
			$target.scrollIntoView({
				block: "start",
				behavior: "smooth"
			});
		}
	}

	withGoogleMapApi(
		apiKey,
		() => render($mapNode, onMarkerClick)
	);
}
